import { render, staticRenderFns } from "./portalContainDialog.vue?vue&type=template&id=10664937&scoped=true"
import script from "./portalContainDialog.vue?vue&type=script&lang=js"
export * from "./portalContainDialog.vue?vue&type=script&lang=js"
import style0 from "./portalContainDialog.vue?vue&type=style&index=0&id=10664937&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10664937",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10664937')) {
      api.createRecord('10664937', component.options)
    } else {
      api.reload('10664937', component.options)
    }
    module.hot.accept("./portalContainDialog.vue?vue&type=template&id=10664937&scoped=true", function () {
      api.rerender('10664937', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newMenu/components/portalContainDialog.vue"
export default component.exports